import { useRef } from 'react';
import { useKenoSound } from '../keno/useKenoSound';

export const useDiceSliderSound = (muted, volume) => {
  const sound = useKenoSound(muted, volume), last = useRef(-Infinity);
  return (position) => {
    const now = performance.now();
    if (now - last.current < 45) return;
    last.current = now;
    sound('slider', position);
  };
};